module.exports = __webpack_public_path__ + "img/piggy.9b110eaf.svg";